// Fallback content shown before the API responds. The DB copy is the source of truth.
const LOGO = "https://customer-assets-jai6qajn.emergentagent.net/job_fort-worth-sourcing/artifacts/rb9547km_fulllogo_transparent.png";
const MACHINED_PARTS = "https://images.unsplash.com/photo-1740209475472-aa7d280f7452?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920";
const FORT_WORTH_SKYLINE = "https://customer-assets-jai6qajn.emergentagent.net/job_fort-worth-sourcing/artifacts/onvh8r3o_pic%202.png";
const FACTORY = "https://images.unsplash.com/photo-1581091212991-8891c7d4bd9b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

export const DEFAULT_CONTENT = {
  brand: { name: "LIEBER SOURCING", tagline: "Quality Sourcing, Trusted Solutions.", logoUrl: LOGO },
  hero: {
    overline: "Fort Worth, Texas — Aerospace & Defense Sourcing",
    titleLines: ["Sourcing the World's Best", "Machining Suppliers"],
    subtitle:
      "Lieber Sourcing helps aerospace, defense, and industrial manufacturers find the best precision-machining suppliers across North America and Europe — while reducing cost and lead time.",
    ctaPrimary: "Request a Sourcing Audit",
    ctaSecondary: "Explore Capabilities",
    backgroundImage: MACHINED_PARTS,
  },
  marqueeText:
    "Aerospace — Defense — Precision Machining — Supplier Intelligence — Cost Reduction — Dual Sourcing — Supplier Recovery — Global Sourcing",
  stats: [
    { value: "15+", label: "Years Global Sourcing" },
    { value: "3", label: "Continents Sourced" },
    { value: "5-Axis", label: "Titanium Capability" },
    { value: "18%", label: "Typical Cost Reduction" },
  ],
  about: {
    overline: "The Edge",
    heading: "A bridge between European precision and North American demand.",
    paragraphs: [
      "Fifteen years sourcing for companies that demand world-class execution — Bosch, Mitsubishi, Safran, Overhead Door, and a major defense drone manufacturer.",
      "Deep knowledge of precision-machining suppliers, backed by a trusted network across the U.S., Europe, and Mexico.",
      "We sell access to manufacturing capacity and strategic supplier intelligence — hard to replace, impossible to automate.",
    ],
    image: FACTORY,
    credentials: ["Aerospace & Defense", "Precision Machining", "Industrial Manufacturing", "Quality Systems", "5-Axis Titanium", "Global Supply Chains"],
  },
  services: [],
  manifesto: { overline: "Why Now", heading: "The timing has never been better.", chapters: [] },
  contact: {
    overline: "Let's Talk",
    heading: "Tell us what's hard to source.",
    subtitle: "Send the drawing, the commodity, or the problem. We'll respond with a plan.",
    email: "contact@liebersourcing.com",
    phone: "+1 (817) 000-0000",
    whatsapp: "18170000000",
    address: "Fort Worth, Texas — DFW Metroplex",
    hours: "Mon–Fri · 8:00–18:00 CT",
    backgroundImage: FORT_WORTH_SKYLINE,
  },
  footer: {
    blurb: "Boutique sourcing for aerospace, defense, and industrial manufacturers. Based in Fort Worth, Texas.",
    copyright: "Lieber Sourcing. All rights reserved.",
  },
};
